/** Uploading a file straight to R2 through a pre-signed PUT URL (POS2-1132).
 *
 * The backend is never on the upload path — it signs a URL and the browser sends the bytes.
 * Two rules, both easy to get wrong and neither obvious from the call site:
 *
 * * **Send only the headers the signer returned.** The signature covers them, so an extra
 *   header is at best ignored and at worst breaks the request — and the app's `Authorization`
 *   header in particular must not travel to R2, which would reject it and would also hand our
 *   Supabase access token to a third-party host.
 * * **Do not set `Content-Length` by hand.** The browser sets it from the body, and the signed
 *   URL binds the value the API was told to expect, so a file of a different size is refused
 *   by R2 rather than silently stored.
 */
export async function putToPresignedUrl({
  url,
  headers,
  file,
}: {
  url: string;
  headers: Record<string, string>;
  file: File;
}): Promise<void> {
  const response = await fetch(url, { method: "PUT", headers, body: file });
  if (!response.ok) {
    throw new Error(`Upload failed (${response.status} ${response.statusText})`);
  }
}
